<template>
    <div>
        <section>
            <div class="container pl0 pr0">
                <div id="banner" :style="'background-image:url(\''+ profileBanner +'\');'"></div>
                <div id="header">
                    <div class="columns is-mobile">
                        <div class="column is-3">
                            <div id="profile-image" :style="'background-image:url(\''+ profileLogo +'\');'">

                            </div>
                        </div>
                        <div class="column is-9">
                            <div id="header-info">
                                <h1>{{profile.name}}</h1>
                                <p class="about-fact-data">{{profile.city}} | {{profile.zip_work}}</p>
                            </div>
                        </div>
                    </div>
                </div>
                <div id="content">
                    <hr class="line">
                    <div id="bar">
                        <a class="bar-link" href="#about"><b>Sobre</b></a>
                        <a class="bar-link" href="#media"><b>Fotografias</b></a>
                        <a class="bar-link" href="#ratings"><b>Avaliações</b></a>
                    </div>
                    <hr class="line" >
                    <div class="about-section" id="about">
                        <div class="columns">
                            <div class="column is-9">
                                <div v-if="profile.about" id="about-text">
                                    <div class="about-item">
                                        <p><b>Quem somos e que serviço prestamos?</b></p>
                                        <p>{{profile.about.info1}}</p>
                                    </div>
                                    <div class="about-item">
                                        <p><b>Como definimos o trabalho por nós feito?</b></p>
                                        <p>{{profile.about.info2}}</p>
                                    </div>
                                    <div class="about-item">
                                        <p><b>Quantos anos temos de experiência?</b></p>
                                        <p>{{profile.about.info3}}</p>
                                    </div>
                                </div>
                                <div v-if="services" class="about-section" id="about-services">
                                    <p><b>Serviços realizados:</b></p>
                                    <div>
                                       <p class="service" v-for="s in services">{{s.title}}</p>
                                    </div>
                                </div>
                            </div>
                            <div class="column is-3">
                                <div id="facts">
                                    <div class="about-fact">
                                        <p><i class="fa fa-map-marker"></i><b>&nbsp;Localização</b></p>
                                        <p class="about-fact-data">{{profile.city}} | {{profile.zip_work}}</p>
                                    </div>
                                    <div class="about-fact">
                                        <p><i class="fa fa-mobile"></i><b>&nbsp;Contacto</b></p>
                                        <p :class="profile.verifications && profile.verifications.phone ? 'yes' : 'no'" class="about-fact-data">{{profile.verifications && profile.verifications.phone ? 'Verificado' : 'Não-verificado'}}</p>
                                    </div>
                                    <div class="about-fact">
                                        <p><i class="fa fa-envelope"></i><b>&nbsp;Email</b></p>
                                        <p :class="profile.status === 3 || profile.status === 2 ? 'yes' : 'no'" class="about-fact-data">{{profile.status === 3 || profile.status === 2  ? 'Verificado' : 'Não-verificado'}}</p>
                                    </div>
                                    <div class="about-fact">
                                        <p><i class="fa fa-globe"></i><b>&nbsp;Website</b></p>
                                        <p :class="profile.verifications && profile.verifications.website ? 'yes' : 'no'" class="about-fact-data">{{profile.verifications && profile.verifications.website ? 'Verificado' : 'Não-verificado'}}</p>
                                    </div>
                                    <div class="about-fact">
                                        <p><i class="fa fa-facebook"></i><b>&nbsp;Facebook</b></p>
                                        <p :class="profile.verifications && profile.verifications.facebook ? 'yes' : 'no'" class="about-fact-data">{{profile.verifications && profile.verifications.facebook ? 'Verificado' : 'Não-verificado'}}</p>
                                    </div>
                                    <div class="about-fact">
                                        <p><i class="fa fa-certificate"></i><b>&nbsp;Anos de Experiência</b></p>
                                        <p class="about-fact-data">{{profile.established ? year - parseInt(profile.established) : 0}}</p>
                                    </div>
                                    <div class="about-fact">
                                        <p><i class="fa fa-users"></i><b>&nbsp;№ de Colaboradores</b></p>
                                        <p class="about-fact-data">{{profile.employees}}</p>
                                    </div>
                                    <div class="about-fact">
                                        <p><i class="fa"></i><b>Aderente Pagamento Seguro</b></p>
                                        <p :class="profile.payment ? 'yes' : 'no'" class="about-fact-data">{{profile.payment ? 'SIM' : 'NÃO'}}</p>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                    <hr class="line">
                    <div class="about-section" id="media">
                        <div class="-header">
                            <p><b>Fotografias</b></p>
                        </div>
                        <div id="gallery">
                            <div class="media-item" v-for="(i,index) in profile.media.images"
                                 :style="'background-image:url(\''+ apiUrl+i.file +'\');'"
                                 @click="showImage(i.file)">
                            </div>
                        </div>

                        <div id="lightbox" v-if="lightbox">
                            <i class="fa fa-times fa-3x close" @click="lightbox=null;"></i>
                            <img :src="lightbox" alt="">
                        </div>

                    </div>

                    <div class="about-section" >
                        <hr class="line">
                        <div id="ratings">
                            <p><b>Avaliações</b></p>
                            <p v-if="!ratings"><span style="margin-right:2rem;"><i class="fa fa-star-o"></i><i class="fa fa-star-o"></i><i class="fa fa-star-o"></i><i class="fa fa-star-o"></i><i class="fa fa-star-o"></i></span><em>Nenhuma avaliação até o momento.</em></p>

                        </div>
                    </div>


                </div>



            </div>
        </section>
    </div>

</template>

<script>
import { apiUrl } from "../vars";
import {scrollTop} from "../plugins/scrollTopMixin";

export default {
	mixins: [scrollTop],

	data() {
    return {
      apiUrl,

      lightbox: null,
      y: null,

      year: null,

      ratings: null,

      profile: {
      	name: "",
          zip_work: "",
          city: "",
        established: 0,
        employees: 0,
        payment: 0,
        about: {},
        media: {
          banner: null,
          profile: null,
          gallery: []
        },
        verifications: {
          facebook: 0,
          website: 0,
          email: 0,
          phone: 0
        }
      },
      services: null
    };
  },
  computed: {
    profileBanner() {
      return this.profile.media && this.profile.media.banner !== null
        ? apiUrl + this.profile.media.banner
        : "/static/images/public_profile/ImagemCapa.png";
    },
    profileLogo() {
      return this.profile.media && this.profile.media.logo !== null
        ? apiUrl + this.profile.media.logo
        : "/static/images/public_profile/ImagemPerfil.jpg";
    }
  },
  beforeRouteEnter(to, from, next) {
    let profile = null;
    let services = null;

    axios.post(apiUrl + "/api/profile/" + to.params.slug).then(res => {
      if (res.data.hasOwnProperty("profile")) {
        profile = res.data["profile"];
        profile.media = JSON.parse(profile.media);
        profile.about = JSON.parse(profile.about);
        profile.verifications = JSON.parse(profile.verifications)
        if (res.data.hasOwnProperty("services")) {
          services = res.data["services"];
        }
        if (res.data.hasOwnProperty("error")) {
          next({ name: "home" });
        }
        next(vm => {
          vm.profile = profile;
          vm.services = services;
        });
      } else {
        next({ name: "home" });
      }
    });
  },
  created() {
    let date = new Date();
    this.year = parseInt(date.getFullYear());
    window.addEventListener("scroll", this.handleScroll);
  },

  methods: {
    showImage(src) {
      this.lightbox = apiUrl + src;
      this.y = window.pageYOffset;
    },

    handleScroll(event) {
      if (this.lightbox) {
        window.scrollTo(0, this.y);
      }
    }
  }
};
</script>
<style lang="scss" scoped>
#lightbox {
  position: fixed;
  width: 100vw;
  height: 100vh;
  border-radius: 8px;
  color: white;
  top: 0;
  left: 0;
  z-index: 11000;
  box-shadow: 5px 5px 15px #333;
  // Default
  background-color: rgba(0, 0, 0, 0.75);
  display: flex;
  justify-content: center;
  align-items: center;

  > .close {
    cursor: pointer;
    position: absolute;
    right: 4rem;
    top: 2.5rem;
  }
}

$banner-height: 18rem;

h1 {
  text-transform: uppercase;
  font-size: 2rem;
}

p {
  font-size: 1rem;
}

#banner {
  background-size: cover;
  width: 100%;
  min-height: $banner-height;
}

#header {
  width: 100%;
  margin-top: -0.2 * $banner-height;
  padding: 0 3rem;
  display: flex;
  flex-direction: row;
  align-items: center;
}

#header .columns {
  width: 100%;
}

#header-info {
  height: 100%;
  padding: 3.5rem 0 1.5rem;
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: left;
}

#header-info h1 {
  font-weight: 600;
}

#profile-image {
  background-size: cover;
  width: 100%;
  border-radius: 100%;
  min-height: $banner-height * 0.6;
  max-height: $banner-height * 0.6;
  min-width: $banner-height * 0.6;
  max-width: $banner-height * 0.6;
}

.bar-link {
  color: black;
  margin-right: 2rem;
}
.about-item {
  margin-bottom: 3rem;
}

.about-fact-data {
  color: #424242;
}

.yes {
  color: green;
}
.no {
  color: darkred;
}

#facts {
  padding: 1rem;
  background-color: #dedede;
}

.about-fact {
  border-bottom: solid 1px white;
  padding: 1rem 0.25rem 0.25rem;
}

.about-fact p {
  font-size: 0.8rem;
}

#gallery {
  width: 100%;
  display: flex;
  flex-wrap: wrap;
}

#gallery .media-item {
  position: relative;
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  margin: 1rem 1rem 0 0;
  min-width: 14rem;
  min-height: 14rem;
  background-position: center;
  background-size: cover;
  cursor: pointer;
  > .-close {
    background-color: rgba(0, 0, 0, 0.2);
    border-radius: 50%;
    min-width: 2rem;
    min-height: 2rem;
    display: flex;
    justify-content: center;
    align-items: center;
    color: white;
    cursor: pointer;
    position: absolute;
    right: 1rem;
    bottom: 1rem;
    z-index: 2;
  }
  > .-close:hover {
    background-color: rgba(233, 0, 84, 0.5);
  }
}

#gallery .media-item:hover {
  -moz-box-shadow: inset 0 0 300px rgba(0, 0, 0, 0.5);
  -webkit-box-shadow: inset 0 0 300px rgba(0, 0, 0, 0.5);
  box-shadow: inset 0 0 300px rgba(0, 0, 0, 0.5);
}

.line {
  color: #969696;
  height: 2px;
}

.about-section {
  margin: 2rem 0 4rem;
}

.about-section:last-child {
  margin: 2rem 0 8rem;
}
</style>



// WEBPACK FOOTER //
// src/pages/PublicProfile.vue